import { ADGroups, AssertionDescriptors } from '../../../utilities/Constants';

import CheckmateSelect from '../../../components/shared/CheckmateSelect';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IValidation } from '../../../interfaces/IError';
import { cloneDeep } from 'lodash';

interface IFieldSelectorProps {
    loading: boolean;
    options: IMultiSelectOption[];
    onEasyUpdateFieldsSelected: (selectedFields: IMultiSelectOption[]) => void;
    onPreventRemoveValue?: (value: IMultiSelectOption) => void;
    selectedFields: IMultiSelectOption[];
    validation: IValidation;
}

export function FieldSelector(props: IFieldSelectorProps) {
    const getAllEasyUpdateFieldsForMultiSelect = () => {
        const fieldsList: IMultiSelectOption[] = cloneDeep(props.options);

        // need to mark fields that are part of an AD Group as read only
        const flatAdGroups = ADGroups.flatMap((group) => group);
        fieldsList.forEach((field) => {
            field.readOnly = flatAdGroups.includes(field.guid?.toUpperCase() ?? '');
        });

        return fieldsList;
    };

    return (
        <div className="row">
            <div className="col-sm-2">
                <label className="text-gray">Fields</label>
            </div>
            <div className="col-sm-10">
                <CheckmateSelect
                    isMulti
                    options={getAllEasyUpdateFieldsForMultiSelect()}
                    value={props.selectedFields}
                    onChange={props.onEasyUpdateFieldsSelected}
                    onPreventRemoveValue={props.onPreventRemoveValue}
                    isLoading={props.loading}
                />
            </div>
            <span className="text-danger">{props.validation.criteria}</span>
        </div>
    );
}
